import { ConnectOrganizationView } from './ConnectOrganizationView';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { GatewayContent } from '../general';
import React from 'react';
import { SyncFirstTimeView } from './SyncFirstTimeView';

import { ConfirmOrganizationView, OnboardingErrorView } from './general';
import { isSyncCompleted, isSyncFailed, isSyncInProgress } from '@sonar-software/sonar-ts-lib';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useLatestSalesforceSync, useOnboardingProgress } from '@hooks';

export const OnboardingView: React.FC = () => {
	const latestSync = useLatestSalesforceSync();
	const { loading, progress, updateProgress } = useOnboardingProgress();

	const handleRestart = () => updateProgress({ isSalesforceConnected: false });

	if (loading || !progress) {
		return <GatewayContent />;
	}

	const {
		isSalesforceConnected,
		isSalesforceSynced,
		missingSalesforceSyncPermission
	} = progress;

	const isConnectedButNotSynced = isSalesforceConnected && !isSalesforceSynced;
	const hasCurrentRunningImport = isSyncInProgress(latestSync?.status);
	const hasSuccessfulImport = isSyncCompleted(latestSync?.status);
	const hasFailedImport = isSyncFailed(latestSync?.status);

	if (isConnectedButNotSynced && hasFailedImport) {
		return <OnboardingErrorView onRestart={ handleRestart } />;
	}

	const showConnect = !isSalesforceConnected;

	const showConfirm = isConnectedButNotSynced && !hasCurrentRunningImport &&
		(missingSalesforceSyncPermission || !hasSuccessfulImport);

	const showSync = isConnectedButNotSynced && (hasCurrentRunningImport || hasSuccessfulImport);

	if (!showConnect && !showConfirm && !showSync) {
		return <GatewayContent />;
	}

	return (
		<Routes>
			{ showSync && <Route
				element={ <SyncFirstTimeView /> }
				path={ FULL_ROUTES.ONBOARDING_SYNC } /> }
			{ showSync && <Route
				element={ <Navigate to={ FULL_ROUTES.ONBOARDING_SYNC } /> }
				path='*' /> }
			{ showConfirm && <Route
				element={ <ConfirmOrganizationView onRestart={ handleRestart } /> }
				path={ FULL_ROUTES.ONBOARDING_CONFIRM } /> }
			{ showConfirm && <Route
				element={ <Navigate to={ FULL_ROUTES.ONBOARDING_CONFIRM } /> }
				path='*' /> }
			{ showConnect && <Route
				element={ <ConnectOrganizationView /> }
				path={ FULL_ROUTES.ONBOARDING_CONNECT } /> }
			{ showConnect && <Route
				element={ <Navigate to={ FULL_ROUTES.ONBOARDING_CONNECT } /> }
				path='*' /> }
		</Routes>
	);
};
